<template>
	<main class="new-edit-classgrade">
		<el-form
			:model="model"
			ref="theForm"
			label-width="100px"
			:rules="validationRules"
			@submit.native.prevent="createUpdateClassgrade"
		>
			<el-form-item label="学校" prop="school_id" v-if="canPickSchool">
				<load-select
					v-model="model.school_id"
					:placeholder="'请选择学校'"
					:options="schoolsPickable"
					:paginate="schoolListPaginate"
					:request="refreshSchoolList"
					@change="onSchoolPicked"
				></load-select>
			</el-form-item>

			<template v-if="!advancedMode">
				<el-form-item label="当前年级" prop="current_grade">
					<el-select
						ref="current-grade"
						v-model.number="model.current_grade"
						placeholder="班级目前处于的年级"
						@change="onGradeChange"
					>
						<el-option
							v-for="item in gradesAvailableForSchool"
							:key="item.id"
							:label="item.name"
							:value="item.id"
						></el-option>
					</el-select>
					<br />
					<small style="color: #909399;">
						* 需要输入未入学或者已毕业班级，请切换到
						<span style="color: #0088ff; cursor: pointer;" @click="advancedMode = true"> 高级模式</span>
					</small>
				</el-form-item>
			</template>
			<template v-else>
				<el-form-item label="入学年份" prop="enroll_year">
					<el-input
						oninput="value=value.replace(/[^\d]/g,'')"
						v-model.number="model.enroll_year"
						placeholder="入学年份，如2019"
						type="number"
						@input="
							$event => {
								if ($event.length > 4) {
									model.enroll_year = $event.slice(0, 4)
								}
							}
						"
					/>
				</el-form-item>

				<el-form-item label="入学年级" prop="enroll_grade">
					<el-select v-model.number="model.enroll_grade" placeholder="入学时的年级" @change="onGradeChange">
						<el-option
							v-for="item in gradesAvailableForSchool"
							:key="item.id"
							:label="item.name"
							:value="item.id"
						></el-option>
					</el-select>
					<br />
					<small style="color: #909399;">
						* 切换到
						<span style="color: #0088ff; cursor: pointer;" @click="advancedMode = false"> 简易模式</span>
					</small>
				</el-form-item>
			</template>

			<el-form-item label="班级序号" prop="seq">
				<el-input type="number" v-model.number="model.seq" placeholder="第几班，请输入1,2,3..." />
			</el-form-item>

			<template v-if="model.school_id">
				<template v-for="(subject, index) in subjectArr">
					<el-form-item :label="subject.name + '教师'" prop="head_teacher_id" :key="index">
						<el-select
							v-model="teachersTemp[subject.slug]"
							:placeholder="`请选择${subject.name}学科老师`"
							@change="changTeacher"
							clearable
						>
							<el-option
								v-for="item in teacherAvailable[subject.slug]"
								:key="item.uid"
								:label="item.account.realname + (item.account.serial ? '(' + item.account.serial + ')' : '')"
								:value="item.uid"
							></el-option>
						</el-select>
					</el-form-item>
				</template>
			</template>
			<template v-else>
				<el-form-item>
					<small style="color: #909399;">
						* 选择学校后填写老师
					</small></el-form-item
				>
			</template>

			<el-form-item>
				<el-button v-if="$route.params.id" type="primary" native-type="submit">更新</el-button>
				<el-button v-else type="primary" native-type="submit">创建</el-button>
			</el-form-item>
		</el-form>
	</main>
</template>
<script>
export default {
	data() {
		return {
			teachersTemp: {},
			subjectArr: [],
			model: {
				enroll_grade: null,
				current_grade: null,
				head_teacher_id: null,
				teacher_ids: []
			},
			advancedMode: false,
			schoolsPickable: [],
			gradesAvailableForSchool: [],
			teacherAvailable: [],
			validationRules: {
				school_id: [
					{
						required: true,
						message: '请选择学校',
						trigger: 'change'
					}
				],
				enroll_year: [
					{
						required: true,
						type: 'integer',
						message: '请输入入学年份',
						trigger: 'change'
					}
				],
				enroll_grade: [
					{
						required: true,
						type: 'integer',
						message: '请输入入学年级',
						trigger: 'change'
					}
				],
				current_grade: [
					{
						required: true,
						type: 'integer',
						message: '请输入当前年级',
						trigger: 'change'
					}
				],
				seq: [
					{
						required: true,
						type: 'integer',
						trigger: 'change',
						validator: (rule, value, callBack) => {
							if (value) {
								if (value < 0) {
									return callBack(new Error('请输入正确的班级序号'))
								} else {
									return callBack()
								}
							} else {
								return callBack(new Error('请输入班级序号'))
							}
						}
					}
				]
			},
			schoolListPaginate: {
				page: 1,
				size: 20,
				last_page: null
			}
		}
	},
	computed: {
		canPickSchool() {
			return (
				this.$store.state.user.userInfo.type == this.$api.account.types.BUREAU_ADMIN.value ||
				this.$store.state.user.userInfo.type == this.$api.account.types.PLATFORM_ADMIN.value
			)
		}
	},
	watch: {
		advancedMode: {
			handler() {
				if (this.$refs.theForm) this.$refs.theForm.clearValidate()
				//编辑模式下的未入学或已毕业班级
				if (this.$route.params.id && (this.model.grade_number < 1 || this.model.grade_number > 12)) {
					if (this.advancedMode == false) this.$message.error('未入学或已毕业班级无法切换到简易模式')
					this.advancedMode = true
				}
			}
		}
	},
	async created() {
		if (this.$route.params.id) {
			// 编辑模式
			this.model = await this.$api.classgrade.show(this.$route.params.id)
			this.schoolsPickable = [this.model.school]
			this.model.current_grade = this.model.grade_number

			//已毕业/未入学转到高级模式
			if (this.model.grade_number < 1 || this.model.grade_number > 12) {
				this.advancedMode = true
			}

			//el-select :v-model 需要根据实际情况重新赋值
			this.model.teachers.forEach(el => {
				this.teachersTemp[el.subject.slug] = el.uid
			})

			this.$emit('breadcrumbChange', [
				{
					name: '编辑',
					to: null
				}
			])
		} else {
			this.$emit('breadcrumbChange', [
				{
					name: '新建',
					to: null
				}
			])

			if (this.$store.state.user.userInfo.type == this.$api.account.types.SCHOOL_ADMIN.value) {
				this.model.school_id = this.$store.state.user.userInfo.school_admin.school_id
			}
		}

		this.refreshClassgradeAvailable()
		this.rereshTeacherAvailabe()

		if (this.canPickSchool) {
			// 可选的学校
			this.refreshSchoolList(this.schoolListPaginate)
		}
	},
	methods: {
		async refreshSchoolList(paginate, more, keyword) {
			let resSg
			switch (this.$store.state.user.userInfo.type) {
				case this.$api.account.types.BUREAU_ADMIN.value:
					resSg = await this.$api.school.list({
						admin_scope: this.$store.state.user.userInfo.bureau_admin.bureau.admin_scope,
						paginate: paginate,
						fu_name: keyword
					})
					break
				case this.$api.account.types.PLATFORM_ADMIN.value:
					resSg = await this.$api.school.list({
						paginate: paginate,
						fu_name: keyword
					})
					break
			}
			this.schoolListPaginate.page = resSg.meta.current_page
			this.schoolListPaginate.last_page = resSg.meta.last_page
			// 如果是加载更多，则合并之前的数据
			this.schoolsPickable = more ? [...this.schoolsPickable, ...resSg.data] : resSg.data
		},
		onSchoolPicked() {
			if (Object.keys(this.teachersTemp).length != 0) this.teachersTemp = {}
			this.refreshClassgradeAvailable()
			this.model.enroll_grade = null
			this.model.head_teacher_id = null
		},
		changTeacher() {
			this.$forceUpdate()
		},
		onGradeChange() {
			//主动赋值current_grande render函数没有自动更新，需手动强制刷新
			this.$forceUpdate()
		},
		async rereshTeacherAvailabe() {
			if (this.model.school_id) {
				for (let i = 0; i < this.subjectArr.length; i++) {
					let res = await this.$api.teacher.list({
						filterBy: {
							school_id: this.model.school_id,
							subject_id: this.subjectArr[i].id
						}
					})
					//组装科目可选教师
					this.$set(this.teacherAvailable, this.subjectArr[i].slug, res.data)
				}
			} else {
				this.subjectArr = []
			}
		},
		async refreshClassgradeAvailable() {
			if (!this.model.school_id) {
				this.gradesAvailableForSchool = []
				this.model.current_grade = null
				return
			}

			let school = await this.$api.school.show(this.model.school_id)
			//学校学科
			this.subjectArr = school.subjects
			this.rereshTeacherAvailabe()
			this.gradesAvailableForSchool = []
			if (school.primary_school) {
				this.gradesAvailableForSchool = this.gradesAvailableForSchool.concat([
					{
						id: 1,
						name: '一年级'
					},
					{
						id: 2,
						name: '二年级'
					},
					{
						id: 3,
						name: '三年级'
					},
					{
						id: 4,
						name: '四年级'
					},
					{
						id: 5,
						name: '五年级'
					},
					{
						id: 6,
						name: '六年级'
					}
				])
			}

			if (school.middle_school) {
				this.gradesAvailableForSchool = this.gradesAvailableForSchool.concat([
					{
						id: 7,
						name: '初一'
					},
					{
						id: 8,
						name: '初二'
					},
					{
						id: 9,
						name: '初三'
					}
				])
			}

			if (school.high_school) {
				this.gradesAvailableForSchool = this.gradesAvailableForSchool.concat([
					{
						id: 10,
						name: '高一'
					},
					{
						id: 11,
						name: '高二'
					},
					{
						id: 12,
						name: '高三'
					}
				])
			}
		},
		createUpdateClassgrade() {
			this.$refs['theForm'].validate(async valid => {
				if (valid) {
					//高级默认二选一
					if (this.advancedMode) {
						this.model.current_grade = null
					} else {
						this.model.enroll_grade = null
						this.model.enroll_year = null
					}

					//组装科目教师id
					this.model.teacher_ids = []
					for (let key in this.teachersTemp) {
						this.model.teacher_ids.push(this.teachersTemp[key])
					}

					if (this.$route.params.id) {
						delete this.model.teachers
						delete this.model.school
						// 更新
						await this.$api.classgrade.update(this.$route.params.id, this.model)
					} else {
						// 创建
						await this.$api.classgrade.create(this.model)
					}

					// 成功后返回
					this.$router.go(-1)
				} else {
					return false
				}
			})
		}
	}
}
</script>

<style lang="scss">
.new-edit-classgrade {
	padding: 30px;

	.el-input {
		width: 350px;
	}
}
</style>
